import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { FC } from 'react';
import AccordionContent from 'ui-kit/components/accordion/AccordionContent';
import { TransfereeAccordionProps } from '../types';
import TransfereeForm from './TransfereeForm';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    accordion: {
      borderRadius: theme.spacing(1),
      marginBottom: theme.spacing(2),
    },
  }),
);

const TransfereeAccordion: FC<TransfereeAccordionProps> = ({
  transferee,
  index,
  onUpdate,
  onDelete,
  validationErrors,
  clearValidationErrors,
}) => {
  const classes = useStyles();

  const handleDelete = () => {
    onDelete?.(index);
  };

  return (
    <AccordionContent
      id={transferee.id || `transferee-${index}`}
      title={`Transferee No. ${index + 1}`}
      expanded={true}
      hideSubtitle={true}
      subtitle={[]}
      data-testid={`fincen-transferee-${index}-accordion`}
      data-testid-edit={`fincen-transferee-${index}-edit-button`}
      data-testid-delete={`fincen-transferee-${index}-delete-button`}
      onDelete={onDelete ? handleDelete : undefined}
      className={classes.accordion}
    >
      <TransfereeForm
        transferee={transferee}
        index={index}
        onUpdate={onUpdate}
        validationErrors={validationErrors}
        clearValidationErrors={clearValidationErrors}
      />
    </AccordionContent>
  );
};

export default TransfereeAccordion;
